import { action, makeObservable, observable } from 'mobx';
import { getEnv } from '@hub/helpers/getters.store';
import ProductStore from './product-store/product-store';
import { SidebarStore } from './sidebar-store/sidebar-store';

class UiStore {
  initialUrl?: string;
  reactEnv?: string;

  productStore: ProductStore;
  sidebarStore: SidebarStore;

  displayedNotifications: Set<string> = new Set<string>();

  isMenuCollapsed = false;

  constructor({ reactEnv }: { reactEnv?: string }) {
    this.reactEnv = reactEnv;
    this.initialUrl = localStorage.getItem('initialUrl') || undefined;
    this.isMenuCollapsed = window.matchMedia('(max-width: 768px)').matches;

    this.productStore = new ProductStore();
    this.sidebarStore = new SidebarStore();

    makeObservable(this, {
      isMenuCollapsed: observable,
      toggleIsMenuCollapsed: action,
      setIsMenuCollapsed: action,
      displayedNotifications: observable,
      setInitialUrl: action,
      clearInitialUrl: action,
    });
  }

  toggleIsMenuCollapsed = () => {
    this.isMenuCollapsed = !this.isMenuCollapsed;
  };

  setIsMenuCollapsed = (value: boolean) => {
    this.isMenuCollapsed = value;
  };

  get getLogoutUrl() {
    const {
      envConfig: { awsClientId: clientId },
    } = getEnv();

    const awsDomain = this.getAwsDomain;

    return `${awsDomain}/logout?client_id=${clientId}&logout_uri=${window.location.origin}`;
  }

  get getAwsDomain() {
    const {
      envConfig: { cognitoPoolName: poolName, awsRegion },
    } = getEnv();

    return (
      import.meta.env.VITE_HUB_AWS_USER_POOL_DOMAIN ||
      `https://${poolName}.auth.${awsRegion}.amazoncognito.com`
    );
  }

  getInitialRedirect(defaultPath: string) {
    const redirect = this.initialUrl ? this.initialUrl : defaultPath;

    return redirect;
  }

  setInitialUrl = (url: string) => {
    this.initialUrl = url;
    localStorage.setItem('initialUrl', url);
  };

  clearInitialUrl = () => {
    // Clear initialUrl after redirection
    this.initialUrl = '';
    localStorage.removeItem('initialUrl');
  };
}

export default UiStore;
